import { ZodError, z } from 'zod';
import type { SignInFormValues } from './types';
import { emailInvalidMsg, emailRequiredMsg, passwordRequiredMsg } from './constants';

export const signInFormSchema = z
    .object({
        email: z
            .string()
            .trim()
            .refine(email => email !== '', {
                message: emailRequiredMsg,
            })
            .refine(email => email === '' || z.string().email().safeParse(email).success, {
                message: emailInvalidMsg,
            }),
        password: z.string().trim().min(1, passwordRequiredMsg),
    })
    .strict();

export const validateSignInForm = (values: SignInFormValues): { [key: string]: string[] | undefined } | undefined => {
    try {
        signInFormSchema.parse(values);
    } catch (error) {
        if (error instanceof ZodError) {
            return error.formErrors.fieldErrors;
        }
    }
    return undefined;
};
